import type { ReactNode } from 'react';

export const symbol_mp: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M283-550h57v102q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-102h56v165q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-181q0-14.45-9.49-24.22Q477.02-600 463-600H266q-14.02 0-23.51 9.78Q233-580.45 233-566v181q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-165Zm317 127h93q14.03 0 23.51-9.49Q726-441.98 726-456v-110q0-14.45-9.49-24.22Q707.03-600 693-600H583q-14.03 0-23.51 9.49Q550-581.03 550-567v182q0 10.83 7.12 17.92 7.11 7.08 18 7.08 10.88 0 17.88-7.08 7-7.09 7-17.92v-38Zm0-50v-77h76v77h-76ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
